var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("app-display", {
                attrs: { label: "Área (ha):", content: _vm.pratica.area }
              }),
              _vm._v(" "),
              _c("app-display", {
                attrs: {
                  label: "Espécies florestais:",
                  content: _vm.formataEspecies(
                    "ESPECIE_FLORESTAL",
                    _vm.pratica.especies
                  ),
                  isContentInNextLine: true
                }
              }),
              _vm._v(" "),
              _c("app-display", {
                attrs: {
                  label: "Espécies frutíferas:",
                  content: _vm.formataEspecies(
                    "ESPECIE_FRUTIFERA",
                    _vm.pratica.especies
                  ),
                  isContentInNextLine: true
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("app-display", {
                attrs: {
                  label: "Data de início da implementação (mês e ano):",
                  content: _vm.formataDataInicio(_vm.pratica.dataInicio)
                }
              }),
              _vm._v(" "),
              _c("app-display", {
                attrs: {
                  label: "Espécies alimentares de ciclo curto e médio:",
                  content: _vm.formataEspecies(
                    "ESPECIE_ALIMENTAR_CICLO_CURTO_E_MEDIO",
                    _vm.pratica.especies
                  ),
                  isContentInNextLine: true
                }
              }),
              _vm._v(" "),
              _c("app-display", {
                attrs: {
                  label: "Espécies adubadeiras ou de serviço:",
                  content: _vm.formataEspecies(
                    "ESPECIE_ADUBEIRAS_OU_DE_SERVICO",
                    _vm.pratica.especies
                  ),
                  isContentInNextLine: true
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("Bioinsumos", {
        attrs: {
          bioinsumo: {
            utilizaBioinsumos: _vm.pratica.utilizaBioinsumos,
            bioinsumos: _vm.pratica.bioinsumos
          }
        }
      }),
      _vm._v(" "),
      _c("Irrigacao", {
        attrs: {
          irrigacao: Object.assign(
            {},
            { possuiIrrigacao: _vm.pratica.possuiIrrigacao },
            _vm.pratica.irrigacao
          )
        }
      }),
      _vm._v(" "),
      _c("Financiamento", {
        attrs: {
          financiamento: {
            financiamentos: _vm.pratica.financiamentos,
            outroFinanciamento: _vm.pratica.outroFinanciamento
          }
        }
      }),
      _vm._v(" "),
      _c("Descricao", { attrs: { descricao: _vm.pratica.descricao } })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", { staticClass: "title-praticas" }, [
        _vm._v("Dados da prática")
      ]),
      _vm._v(" "),
      _c("hr")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-924d9062", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-924d9062","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Modals/VisualizacaoCadastro/Cadastro/Praticas/SAF/SAF.vue
// module id = null
// module chunks = 